(function ($) {
    'use strict';

    $.fn.simplePopup = function (config) {
        const $self = $(this);

        let defaults = {
            callback: {
                open: null,
                close: null,
            },
            $template: {},
            mainClass: '',
            closeOnBgClick: true,
            preLoader: false,
            buttonCloseClass: 'js-popup-simple-close',
            hiddenPopupClass: 'visually-hidden',
            cloneTemplate: true,
            customCloseButton: false,
        };

        /**
         * @type {Object} настройки плагина
         */
        let settings = $.extend({}, defaults, config);

        let $template = settings.$template;

        if (settings.cloneTemplate) {
            $template = settings.$template.clone();
        }

        let $defaultCloseButton = $('<button>', {
            class: 'popup-close' + ' ' + settings.buttonCloseClass,
            type: 'button'
        });

        /***
         * Добавить крестик в шаблон
         */
        const addCloseButton = () => {
            if (settings.customCloseButton) {
                return;
            }
            
            $template.prepend($defaultCloseButton);
        };

        /***
         * Открыть popup
         */

        const openPopup = function () {
            addCloseButton();

            $.magnificPopup.open({
                items: {
                    src: $template,
                    type: 'inline'
                },
                mainClass: settings.mainClass,
                preloader: settings.preLoader,
                closeOnBgClick: settings.closeOnBgClick,
                callbacks: {
                    open: function() {
                        $template.removeClass(settings.hiddenPopupClass);
                        SVK.makeFixedHtml();

                        if (settings.callback.open) {
                            settings.callback.open.apply();

                        }
                    },
                    close: function() {
                        SVK.makeUnfixedHtml();

                        if (settings.callback.close) {
                            settings.callback.close.apply();
                        }
                    }
                }
            });

        };

        const initEvents = function () {
            $(document).on('click', '.' + settings.buttonCloseClass, function () {
                $.magnificPopup.close();
            });
        };


        const init = function () {
            openPopup();
            initEvents();
        };

        init();

    };
})(jQuery);
